import React, { createContext, useEffect, useState } from 'react'
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import { useAppCtx } from './app-ctx';

import ResortLoader from './resort-loader';
import ResortDetailsShort from './resort-details-short-v2';
import BookForm from './book-form';

import FormValidationContext from './form-validation-ctx';


const BookPage = ({resortId}) => {
    const {searchCriterias} = useAppCtx();
    const { t } = useTranslation();
    console.log(`BookPage().Entry: resortId=${resortId}, searchCriterais=, ${JSON.stringify(searchCriterias)}`);
    return (
        <>
            <ResortLoader resortId={resortId}>
                {(theResort) => {
                        if (!theResort) {
                            return <div className="loading">{t('Loading ...')}</div>;
                        }

                        if (theResort.name) {
                            document.title = `${t('Booking')} ${theResort.name} - ${window.location.hostname}`;
                        }

                        return (
                            <>
                                <ResortDetailsShort theResort={theResort} />
                                <FormValidationContext>
                                    <BookForm resortId={resortId} theResort={theResort}/>
                                </FormValidationContext>
                            </>
                        );
                    }
                }
            </ResortLoader>
            
        </>
    )
}

export  default BookPage;